import { useMemo } from 'react';
import { GetBeneficiarySchema } from 'shared/data/webApp/v1';

import {
    keysAddress,
    keysBankDetails,
    stepOneRenderedKeys,
    stepTwoRenderedKeys,
} from '../../AddBeneficiaryPopupContent.constants';
import { getMiscKeys, mapKeysToFields } from './StepFour.helpers';
import { messages } from './StepFour.messages';

export const useGetSections = (fields: GetBeneficiarySchema['response']['schema']['fields']) => {
    return useMemo(() => {
        const fieldsGeneral = mapKeysToFields(stepOneRenderedKeys, fields);
        const fieldsPaymentMethod = mapKeysToFields(stepTwoRenderedKeys, fields);
        const fieldsBankDetails = mapKeysToFields(keysBankDetails, fields);
        const fieldsAddress = mapKeysToFields(keysAddress, fields);

        const keysMisc = getMiscKeys(
            [...stepOneRenderedKeys, ...stepTwoRenderedKeys, ...keysBankDetails, ...keysAddress],
            fields
        );
        const fieldsMisc = mapKeysToFields(keysMisc, fields);

        return [
            {
                name: messages.sectionGeneralInfo,
                fields: fieldsGeneral,
            },
            {
                name: messages.sectionPaymentMethod,
                fields: fieldsPaymentMethod,
            },
            {
                name: messages.sectionBankDetails,
                fields: fieldsBankDetails,
            },
            {
                name: messages.sectionAddress,
                fields: fieldsAddress,
            },
            {
                name: messages.sectionMisc,
                fields: fieldsMisc,
            },
        ];
    }, [fields]);
};
